import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiClientInterface } from '../../client/api/api-client.interface';
import { Transaction } from '../transaction/transaction';
import { TransactionRequestInterface } from '../transaction/transaction-request.interface';
import { UserInterface } from '../data';

@Injectable()
export class UserApiRepository {
    constructor(private apiClient: ApiClientInterface, private transactionRequest: TransactionRequestInterface) {}

    load(): Observable<Transaction<UserInterface>> {
        return this.transactionRequest.wrap(this.apiClient.getProfile());
    }
}
